module.exports = __webpack_public_path__ + "img/welcome-to-apvertise.d52d5426.png";